import React, { useEffect, useRef, useState } from "react";
import useTranslate from "../../hooks/useTranslate";

// House-rule line + "Lounge rules" popover — frames 1a/1e (wording fixed by
// the design inventory: four rules, 01–04). Mobile: the popover stretches to
// the column edges (1e).

const RULES = [
  {
    lead: "Real names.",
    body: "Every post carries your verified agent identity.",
  },
  {
    lead: "Craft yes, names no.",
    body: "No club names, no player names, no active deals.",
  },
  {
    lead: "Disagree politely.",
    body: "Argue the point, vote the rest.",
  },
  {
    lead: "Report handles the rest.",
    body: "The only moderation control in the lounge.",
  },
];

const HouseRuleLine = () => {
  const { t } = useTranslate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={ref} className="relative mt-2.5">
      <p className="m-0 text-[11.5px] min-[402px]:text-[12px] sm:text-[12.5px] text-[#9CA3AF]">
        {t("House rule: craft yes, names no.")} ·{" "}
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          className="border-none bg-transparent p-0 text-[11.5px] min-[402px]:text-[12px] sm:text-[12.5px] font-semibold text-[#2283FF] whitespace-nowrap"
        >
          {t("Lounge rules")}
        </button>
      </p>
      {open && (
        <div className="absolute top-[26px] sm:top-7 left-0 right-0 sm:right-auto z-20 sm:w-[400px] bg-white border border-[#E4E9F0] rounded-[14px] shadow-[0_16px_40px_rgba(17,24,39,0.10)] overflow-hidden">
          <div className="flex items-center py-3 px-[15px] sm:py-[13px] sm:px-[18px] border-b border-[#EEF1F5]">
            <span className="text-[13.5px] sm:text-[14px] font-bold text-[#111827] tracking-[-0.1px]">
              {t("Lounge rules")}
            </span>
            <span className="flex-1" />
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label={t("Close")}
              className="border-none bg-transparent text-[#9CA3AF] text-[15px] leading-none py-[5px] px-[9px] sm:py-[3px] sm:px-[7px] rounded-[7px] hover:bg-[#F1F4F8] hover:text-[#111827]"
            >
              ×
            </button>
          </div>
          <div className="py-2 pb-3">
            {RULES.map((rule, i) => (
              <div key={rule.lead} className="flex gap-2.5 sm:gap-3 py-2 px-[15px] sm:py-[9px] sm:px-[18px]">
                <span className="font-mono text-[10.5px] sm:text-[11px] font-bold text-[#2283FF] pt-[3px]">
                  {`0${i + 1}`}
                </span>
                <p className="m-0 text-[12.5px] sm:text-[13px] leading-[1.5] text-[#6B7280]">
                  <span className="font-semibold text-[#111827]">{t(rule.lead)}</span>{" "}
                  {t(rule.body)}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HouseRuleLine;
